import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import TransactionScreen from "./screen/transaction/TransactionScreen.js";
import { ToastContainer } from "react-toastify";
import PriceScreen from "./screen/price/PriceScreen.js";
import AuthScreen from "./screen/auth/AuthScreen.js";
import NotFoundScreen from "./screen/notfound/NotFoundScreen.js";
import Navbar from "./components/Navbar.js"; // Import Navbar
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import StatScreen from "./screen/stats/StatScreen.js";

const isAuthenticated = () => {
    const token = localStorage.getItem("token");
    return !!token;
};

const ProtectedRoute = ({ element }) => {
    return isAuthenticated() ? element : <Navigate to="/auth" />;
};

const AuthRoute = ({ element }) => {
    return isAuthenticated() ? <Navigate to="/transaction" /> : element;
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                {!window.location.pathname.includes("/auth") && <Navbar />}
                <Routes>
                    <Route
                        path="/transaction"
                        element={<ProtectedRoute element={<TransactionScreen />} />}
                    />
                    <Route
                        path="/price"
                        element={<ProtectedRoute element={<PriceScreen />} />}
                    />
                    <Route
                        path="/auth"
                        element={<AuthRoute element={<AuthScreen />} />}
                    />
                    <Route
                        path="/stats"
                        element={<ProtectedRoute element={<StatScreen />} />}
                    />
                    <Route path="*" element={<NotFoundScreen />} />
                </Routes>
                <ToastContainer />
            </BrowserRouter>
        </div>
    );
}

export default App;